export function isInMobileDevice(): boolean {
  return document.body.classList.contains('mobile');
}
export function isInMobileApp(): boolean { // Capacitor
  return document.body.classList.contains('capacitor');
}
export function isInIOSApp(): boolean {
  return document.body.classList.contains('platform-ios');
}
export function isInAndroidApp(): boolean {
  return document.body.classList.contains('platform-android');
}

export function isInOldCordovaApp(): boolean {
  return navigator.userAgent.includes('tokatab-cordova-app');
}

export function getMobileOrientation(): 'portrait' | 'landscape' {
  return (screen.height > screen.width) ? 'portrait' : 'landscape';
}

export function isTablet() {
  return document.body.classList.contains('tablet');
}
